import { MessageTypeEnumValue } from 'enums/MessageTypeEnum';
import { useDispatch } from 'react-redux';
import { SHOW_MESSAGE } from 'redux/Message/MessageType';

export default function useToast() {
  const dispatch = useDispatch();
  const dispatchMessageAsync = payload => {
    setTimeout(() => {
      dispatch({
        type: SHOW_MESSAGE,
        payload,
      });
    }, 0);
  };

  return {
    saveMessage: () => {
      dispatch({
        type: SHOW_MESSAGE,
        payload: { type: MessageTypeEnumValue.Success, messageKey: 'saved_successfully' },
      });
      return false;
    },
    uniqueSaveMessage: () => {
      dispatch({
        type: SHOW_MESSAGE,
        payload: { type: MessageTypeEnumValue.Success, messageKey: 'saved_successfully', preventDuplicate: true },
      });
      return false;
    },
    deleteMessage: () => {
      dispatch({
        type: SHOW_MESSAGE,
        payload: { type: MessageTypeEnumValue.Success, messageKey: 'deleted_successfully' },
      });
      return false;
    },
    errorMessage: error => {
      let payload = null;

      if (error?.response?.status === 400) {
        let message = '';
        if (error.response.data === 'PromotionQuantityExceeded') {
          message = 'promotionQuantityExceeded';
        } else if (error.response.data === 'InventoriedItemDepletedRequiresReplacement') {
          message = 'inventoriedItemDepletedRequiresReplacement';
        } else if (error.response.data === 'InventoriedItemQuantityExceeded') {
          message = 'inventoriedItemQuantityExceeded';
        } else if (error.response.data === 'InventoriedItemReplacementUnavailable') {
          message = 'inventoriedItemReplacementUnavailable';
        } else {
          message = error.response.data;
        }
        payload = {
          type: MessageTypeEnumValue.Danger,
          messageKey: message || 'data_not_available',
          preventDuplicate: true,
        };
      } else if (error?.response?.status === 401) {
        payload = {
          type: MessageTypeEnumValue.Danger,
          messageKey: error.response.data || 'data_access_denied',
          preventDuplicate: true,
        };
      } else if (error?.response?.status === 409) {
        payload = {
          type: MessageTypeEnumValue.Danger,
          messageKey: error.response.data || 'data_current_state_wrong',
          preventDuplicate: true,
        };
      } else {
        payload = {
          type: MessageTypeEnumValue.Danger,
          messageKey: error.message,
          preventDuplicate: true,
        };
      }

      dispatchMessageAsync(payload);

      return false;
    },
    offlineMessage: () => {
      dispatch({
        type: SHOW_MESSAGE,
        payload: { type: MessageTypeEnumValue.Danger, messageKey: 'now_offline' },
      });
      return false;
    },
    onlineMessage: () => {
      dispatch({
        type: SHOW_MESSAGE,
        payload: { type: MessageTypeEnumValue.Success, messageKey: 'now_online' },
      });
      return false;
    },
  };
}
